import { AfterViewInit, Component, ComponentRef, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import moment from 'moment';
import { CpxHandleServiceAbstract } from 'src/app/services/cpx-handle/cpx-handle-service-abstract';
import { CadreExerciceIsMissing, CannotCreateTlsiConnector, CannotOpenSession, CannotRetreiveIns, MultipleIdentitiesFound, NoIdentityFound, NoIdentityInfos } from 'src/app/services/ins/ins.error';
import { InsRealservice } from 'src/app/services/ins/ins.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { StringUtilsService } from 'src/app/services/string-utils/string-utils.service';
import { InsIdentityInfos } from 'src/app/utils/interfaces/new/ins-identity-infos.interface';
import { Patients } from 'src/app/utils/interfaces/new/lecture-carte-vitale';
import { LectureIns } from 'src/app/utils/interfaces/new/lecture-ins.interface';
import { environment } from 'src/environments/environment';

export interface InsiInfosPatient {
  birthName: string;
  birthPlace: string;
  birthday: string;   // format DD/MM/YYYY
  firstName: string;
  firstNameUsed: string;
  firstNames: string;
  ins: string;
  insKey: string;
  mIns: string;
  nameUsed: string;
  oid: string;
  sex: string;
}

@Component({
  selector: 'app-insi',
  templateUrl: './insi.fragment.html',
  styleUrls: ['./insi.fragment.scss', '../modal.fragment.scss'],
})
export class InsiFragment implements OnInit, AfterViewInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  public modalTitle: string;
  public formGroup: FormGroup;
  public isError = false;
  public errorMessage = 'Veuillez renseigner le nom, le prénom et la date de naissance';
  public isLoading = false;
  public notFoundError: string;
  public noPatientFoundMsg: string;
  public showDetails = false;
  public isFirstAttempt = true;

  @Output() public closeEmitter = new EventEmitter<InsiInfosPatient | undefined>();

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeInsiModal();
    }
  }

  public sexes = [
    // { id: 1, libelle: 'Inconnu' },
    { id: 2, libelle: 'Masculin' },
    { id: 3, libelle: 'Féminin' }
  ];

  public patientVitaleColumnTable = [
    { title: 'Nom', data: 's_name' },
    { title: 'Nom de naissance', data: 's_birthname' },
    { title: 'Prénom', data: 's_given' },
    { title: 'Date de naissance', data: 's_birthday' },
    { title: 'NIR', data: 's_nir' },
    { title: 'INSC', data: 's_insC' },
  ];

  public patientColumnTable = [
    { title: '', data: 'tag', isCellColor: true },
    { title: 'Patient', data: 'nomPrenomDateNaissance' },
    { title: 'Nom de naissance', data: 'nomNaissance' },
    { title: 'Nom d\'usage', data: 'nomUsage' },
    { title: 'Suivi par', data: 'suiviPar' },
    { title: 'ROSP', data: 'isRospLabel' },
    { title: 'Note', data: null }
  ];


  public selectedData: any;
  public isSubmitDisabled: boolean = false;

  public dataBodyTable = {
    page: 1,
    perpage: -1,
    total: 0,
    objects: []
  };
  public dataColumnTable = [
    { title: '', data: 'tag', isCellColor: true },
    { title: 'Matricule INS (et historique)', data: 'mIns' },
    // { title: 'OID', data: 'oid' },
    { title: 'Nom naissance', data: 'birthName' },
    // { title: 'Nom utilisé', data: 'nameUsed' },
    { title: 'Prénom(s) de naissance', data: 'firstNames' },
    // { title: '1er prénom', data: 'firstName' },
    // { title: 'Prénom utilisé', data: 'firstNameUsed' },
    { title: 'Date naissance', data: 'birthday' },
    { title: 'Sexe', data: 'sex' },
    { title: 'Code lieu de naissance', data: 'birthPlace' },
    // { title: 'Nature justificatif de l\'identité', data: 'proofIdentity' }
  ];

  // Variable pour conserve la largeur du tableau
  public tableWidth = 0;

  constructor(
    private _formBuilder: FormBuilder,
    private _modalService: ModalService,
    private _view: ViewContainerRef,
    private _ins: InsRealservice,
    private _cpxService: CpxHandleServiceAbstract,
    //private _ins: InsService,
    private _strUtils: StringUtilsService,
    private _router: Router,
  ) { }

  ngOnInit(): void {
    this.formGroup = this._formBuilder.group({
      sexe: [environment.production ? '' : '', Validators.required],
      nomNaissance: [environment.production ? '' : '', [Validators.required, Validators.maxLength(80)]],
      prenom: [environment.production ? '' : '', [Validators.required, Validators.maxLength(61), Validators.pattern(/^(?!\s*$).+/)]],
      dateNaissance: [environment.production ? '' : '', Validators.required],
      lieuNaissance: ['', [Validators.minLength(5), Validators.maxLength(5)]],
    });
  }

  ngAfterViewInit() {
    /**
     * On récupère la largeur du tableau.
     * Cela nous sera utile si une erreur survient lors de la recherche.
     * En effet, on va utiliser cette valeur pour setter la largeur de l'encart de message
     * et ainsi éviter un grande diminution de la largeur de la modal
     */
    this.tableWidth = document.getElementById('search-insi-result-table').offsetWidth;
  }

  public stopPropagation(event: any): void {
    event.stopPropagation();
  }

  public async onSubmit(isManualSubmit: boolean = false): Promise<void> {
    if (isManualSubmit) {
      // Pour respecter les exigences de l'INSi : une nouvelle recherche manuelle
      // doit obligatoirement commencer sans le COG (lieu de naissance).
      this.isFirstAttempt = true;
    }
    this.notFoundError = '';
    this.noPatientFoundMsg = '';
    this.showDetails = false;

    // On vide le tableau de résultats avant chaque recherche pour une meilleur compréhension pour l'utilisateur
    this.dataBodyTable.objects = [];

    this.formGroup.markAllAsTouched();

    if (this.formGroup.valid) {
      // match accents and specials characters
      const normalizeName = this._strUtils.removeAccents(this.formGroup.controls['nomNaissance'].value as string).normalize('NFKD').toUpperCase();
      const normalizeGiven = this._strUtils.removeAccents(this.formGroup.controls['prenom'].value as string).normalize('NFKD').toUpperCase();

      const reg1 = new RegExp(/^[A-Z'][A-Z'\-\s]*$/);
      const reg2 = new RegExp(/  |''|' | '/);
      const regNom = new RegExp(/^([-].*)|(.*['-])$/);
      const regPrenom = new RegExp(/^(['-].*)|(.*['-])$/);

      if (!normalizeName.match(reg1) || (normalizeName.match(reg1) && (normalizeName.match(reg2) || normalizeName.match(regNom)))) {
        this._modalService.openAlert(this._view, 'Erreur dans le nom de famille', 'Le nom de famille renseigné n\'est pas conforme au format attendu : \n- Ne doit contenir que les lettres de A à Z, tirets (-), apostrophes (\') ou espaces\n- Ne doit pas commencer par un espace ou un tiret\n- Ne doit pas contenir 2 espaces ou apostrophes consécutifs)');
        return;
      }

      if (!normalizeGiven.match(reg1) || (normalizeGiven.match(reg1) && (normalizeGiven.match(reg2) || normalizeGiven.match(regPrenom)))) {
        this._modalService.openAlert(this._view, 'Erreur dans le prénom', 'Le prénom renseigné n\'est pas conforme au format attendu : \n- Ne doit contenir que les lettres de A à Z, tirets (-), apostrophes (\') ou espaces\n- Ne doit pas commencer par un espace ou un tiret\n- Ne doit pas contenir 2 espaces ou apostrophes consécutifs)');
        return;
      }

      let object: InsIdentityInfos = {
        s_given: normalizeGiven,
        s_birthDate: moment(this.formGroup.controls['dateNaissance'].value).format('YYYY-MM-DD'),
        i_sex: this.formGroup.controls['sexe'].value && this.formGroup.controls['sexe'].value !== ''
            ? this.formGroup.controls['sexe'].value : undefined,
        s_birthName: normalizeName,
        // Le téléservice INSi exige de ne pas envoyer le COG au 1er appel. 
        // Il ne sera envoyé qu'en cas de relance suite à un retour "Identités multiples".
        s_birthPlace: this.isFirstAttempt ? "" : (this.formGroup.controls['lieuNaissance'].value || ""),
      };

      const listPatientsIns = await this._getIns(object);
      
      if (listPatientsIns === 'RETRY_WITH_COG') {
        this.isFirstAttempt = false;
        await this.onSubmit();
        return;
      }
      
      if (listPatientsIns) {
        this.isFirstAttempt = true; // Réinitialise pour les futurs appels éventuels
        this._initTableIns(listPatientsIns as LectureIns);
      } else {
        this.noPatientFoundMsg = 'Aucun patient n\a été trouvé pour cette recherche';
      }
    }
  }

  private async _getIns(infosIdentity: InsIdentityInfos): Promise<LectureIns | 'RETRY_WITH_COG' | undefined> {
    const loadingModal = this._modalService.openLoading(this._view);
    this.isLoading = true;

    try {
      return await this._ins.getInsFromIdentityInformation(this._view, infosIdentity);
    } catch (e) {
      if (e instanceof CannotOpenSession) {
        this._modalService.openAlert(this._view, 'Erreur', 'Impossible d\'ouvrir la session.');
      } else if (e instanceof CannotCreateTlsiConnector) {
        this._modalService.openAlert(this._view, 'Erreur', 'Impossible de créer la connexion.\nVérifiez que votre carte CPS soit bien introduite.', undefined, e.message);
      } else if (e instanceof NoIdentityInfos) {
        this._modalService.openAlert(this._view, 'Erreur', 'Veuillez renseigner le formulaire de recherche.');
      } else if (e instanceof CannotRetreiveIns) {
        // this._modalService.openAlert(this._view, 'Erreur', 'Impossible de récupérer l\'ins.', undefined, e.message);
        this.notFoundError = e.message;
      } else if (e instanceof NoIdentityFound) {
        this._showAdviceModal('Aucune identité n’a été trouvée par le téléservice INSi.');
      } else if (e instanceof MultipleIdentitiesFound) {
        if (this.isFirstAttempt) {
          // Des homonymes ont été trouvés au 1er appel (sans COG).
          // On passe au 2e essai et on relance la requête (cette fois avec le COG s'il est renseigné).
          this.isFirstAttempt = false;
          if (this.formGroup.controls['lieuNaissance'].value && this.formGroup.controls['lieuNaissance'].value !== '') {
            return 'RETRY_WITH_COG';
          } else {
            // Si pas de COG initial, on ne fait pas de relance inutile, on affiche l'erreur
            this._showAdviceModal('Plusieurs identités approchantes ont été trouvées par le téléservice INSi. Affinez votre recherche et / ou utilisez la carte Vitale de l’usager.');
          }
        } else {
          // Le 2e appel avec COG a quand même renvoyé des homonymes (ou COG invalide)
          this._showAdviceModal('Plusieurs identités approchantes ont été trouvées par le téléservice INSi. Affinez votre recherche et / ou utilisez la carte Vitale de l’usager.');
        }
      } else if (e instanceof CadreExerciceIsMissing) {
          const modal = this._modalService.openModalMultipleChoice(
            this._view,
            'Informations manquantes',
            e.message,
            'Que voulez-vous faire ?',
            [{
              label: 'Accéder aux paramètre de DMP',
              value: 'goToParams'
            }, {
              label: 'Fermer',
              value: 'close',
              backgroundColor: 'var(--darkest-primary)'
            }]
          );

          const sub = modal.instance.closeEmitter.subscribe((val: string) => {
            if (val === 'goToParams') {
              this._router.navigateByUrl('/user/parametres/dmp');
            }
            sub.unsubscribe();
            modal.destroy();
          });
      }
    } finally {
      this.isLoading = false;
      this._modalService.close(loadingModal);
    }
    return undefined;
  }

  private _showAdviceModal(message: string): void {
    const modal = this._modalService.openModalMultipleChoice(
      this._view,
      'Erreur',
      message,
      'Pour plus d\'informations sur la Conduite à tenir lors du retour du Téléservice INSi : « plusieurs identités trouvées » ou « aucune identité trouvée », consultez la fiche pratique :',
      [
        { label: 'Fiche pratique', value: 'pdf' }
      ]
    );

    const sub = modal.instance.closeEmitter.subscribe((val: string) => {
      if (val === 'pdf') {
        window.open('https://esante.gouv.fr/sites/default/files/media_entity/documents/%5BINS%20au%20quotidien%5D%20Conduite%20%C3%A0%20tenir%20en%20fonction%20du%20retour%20d%27INSi.pdf', '_blank');
      }
      sub.unsubscribe();
      modal.destroy();
    });
  }

  private _initTableIns(listPatientsIns: LectureIns) {
    let mIns = listPatientsIns.Identity.Ins.s_value + listPatientsIns.Identity.Ins.s_key;

    if (listPatientsIns.Identity.Ins.s_oid === '1.2.250.1.213.1.4.9') {
      mIns = `${mIns}\n(INS provisoire)`;
    }

    if (listPatientsIns.Identity.History && listPatientsIns.Identity.History.length > 0) {
      mIns = `${mIns}\n\n(Historique : ${listPatientsIns.Identity.History.map(h => `${h.s_value}${h.s_key}${h.s_oid === '1.2.250.1.213.1.4.9' ? ' (provisoire)' : ''}`).join(',\n')})`;
    }
    // tagColor
    // vert #ACDA7A
    // rouge #B51621
    // jaune #FFEC60
    // bleu #006FC0
    this.dataBodyTable.objects = [{
      tag: 'B51621',
      mIns,
      oid: listPatientsIns.Identity.Ins.s_oid,
      birthName: listPatientsIns.Identity.s_birthName,
      nameUsed: listPatientsIns.Identity.s_birthName,
      birthday: moment(listPatientsIns.Identity.s_birthDate).format('DD/MM/YYYY'),
      firstNames: listPatientsIns.Identity.s_birthGiven,
      firstName: listPatientsIns.Identity.s_birthGiven.split(' ')[0],
      firstNameUsed: listPatientsIns.Identity.s_given,
      birthPlace: listPatientsIns.Identity.s_birthPlace,
      sex: this._getSexName(listPatientsIns),
      proofIdentity: listPatientsIns.i_insIdentityResult,
      ins: listPatientsIns.Identity.Ins.s_value,
      history: listPatientsIns.Identity.History,
      insKey: listPatientsIns.Identity.Ins.s_key
    }];
  }

  private _getSexName(patientIns: LectureIns) {
    let sexName: string;
    switch (patientIns.Identity.i_sex) {
      case 1: {
        sexName = "Inconnu";
        break;
      }
      case 2: {
        sexName = "Masculin";
        break;
      }
      case 3: {
        sexName = "Féminin";
        break;
      }
      default: {
        sexName = "Inconnu";
        break;
      }
    }
    return sexName;
  }

  public selectedValue(event: any) {
    if (this.selectedData === event) {
      this._doSelectValue({ doSelect: false, valueId: event.id });
      this.selectedData = undefined;
    } else {
      if (this.selectedData) {
        this._doSelectValue({ doSelect: false, valueId: this.selectedData.id });
      }
      this.selectedData = event;
      this._doSelectValue({ doSelect: true, valueId: event.id });
    }
  }

  private _doSelectValue(value: any): void {
    if (this.dataBodyTable && this.dataBodyTable.objects) {
      const index = this.dataBodyTable.objects.findIndex(p => p.id === value.valueId);
      const valueDisplayTable = this.dataBodyTable.objects.find(p => p.id === value.valueId);

      if (value.doSelect) {
        Object.defineProperty(valueDisplayTable, 'rowColor', { configurable: true, value: 'var(--primary)' });
        Object.defineProperty(valueDisplayTable, 'textColor', { configurable: true, value: 'var(--white)' });
      } else {
        Object.defineProperty(valueDisplayTable, 'rowColor', { configurable: true, value: 'transparent' });
        Object.defineProperty(valueDisplayTable, 'textColor', { configurable: true, value: 'var(--black)' });
      }
      this.dataBodyTable.objects.splice(index, 1, valueDisplayTable);
    }
  }

  public submitIdentity() {
    // bouton à désactiver si l'identité sélectionnée n'est pas qualifié
    if (this.selectedData) {
      this.closeInsiModal(this.selectedData);
    }
    else {
      this._modalService.openAlert(this._view, 'Erreur', 'Veuillez sélectionner un patient.');
    }
  }

  async lectureCarteVitale() {
    const loadingModal = this._modalService.openLoading(this._view);
    this.isLoading = true;

    try {
      const listPatientsCarte = await this._cpxService.lectureVitale(this._view);
      console.log('v : ', listPatientsCarte);
      this._modalService.close(loadingModal);
      this.isLoading = false;
      if (listPatientsCarte.Patients.length > 0 && listPatientsCarte.i_cardStatus != 1) {
        const infosPatientCarte: any[] = [];
        for (let [index, patient] of listPatientsCarte.Patients.entries()) {
          let birthday = '';
          if (patient.s_birthday && moment(patient.s_birthday, "DDMMYYYY").isValid()) {
            birthday = moment(patient.s_birthday, "DDMMYYYY").format("DD/MM/YYYY");
          } else if (patient.s_birthdayYYYYMMDD && moment(patient.s_birthdayYYYYMMDD, "YYYYMMDD").isValid()) {
            birthday = moment(patient.s_birthdayYYYYMMDD, "YYYYMMDD").format("DD/MM/YYYY");
          } else if (patient.s_birthdayYYMMDD && moment(patient.s_birthdayYYMMDD, "YYMMDD").isValid()) {
            birthday = moment(patient.s_birthdayYYMMDD, "YYMMDD").format("DD/MM/YYYY");
          }

          infosPatientCarte.push({
            id: index,
            i_birthRank: patient.i_birthRank,
            i_quality: patient.i_quality,
            s_birthday: birthday,
            s_birthname: patient.s_birthname,
            s_certifiedNir: patient.s_certifiedNir ? patient.s_certifiedNir : undefined,
            s_given: patient.s_given,
            s_insC: patient.s_insC ? patient.s_insC : undefined,
            s_name: patient.s_name,
            s_nir: patient.s_nir ? patient.s_nir : undefined
          });
        }
        if (infosPatientCarte.length === 1) {
          await this._getInsFromVitale(infosPatientCarte[0], infosPatientCarte);
        } else {
          this._openModalPatientCarteVitale(infosPatientCarte);
        }
      } else {
        this._modalService.openAlert(this._view, 'Erreur', 'Carte absente');
        if (loadingModal) {
          loadingModal.destroy();
        }
        this.isLoading = false;
      }
    } catch (e) {
      this._modalService.openAlert(this._view, 'Erreur', 'Impossible de lire la carte vitale.');
      if (loadingModal) {
        loadingModal.destroy();
      }
      this.isLoading = false;
      throw (e);
    }
  }

  private async _getInsFromVitale(res: Patients, infos: any): Promise<void> {
    const loading = this._modalService.openLoading(this._view);

    try {
      const patient = await this._ins.getInsFromVitaleCard(this._view, infos.findIndex((p) => {
        return (
          p.s_birthname === res.s_birthname
          && p.s_birthday === res.s_birthday
          && p.id === res.id
          && p.s_name === res.s_name
          && p.s_given === res.s_given
          && p.s_insC === res.s_insC
        );
      }));

      if (patient) {
        this._initTableIns(patient);
      }
    } catch (e) {
      let msg = 'Une erreur est survenue lors de la récupération de l\'INS du patient';
      if (e.message && e.message !== '') {
        msg = e.message;
      }
      this._modalService.openAlert(
        this._view,
        'Erreur',
        msg
      );
    } finally {
      loading.destroy();
    }
  }

  private _openModalPatientCarteVitale(infos: any[]) {
    const modal = this._modalService.openModalSelectList(this._view, 'Patient(s) carte vitale', this.patientVitaleColumnTable, infos, 'Veuillez sélectionner un patient.');
    modal.instance.validButtonLabel = 'Sélectionner';
    const sub = modal.instance.closeEmitter.subscribe(async (res: any) => {
      try {
        if (res) {
          const load = this._modalService.openLoading(this._view);

          const listPatientsCarte = await this._cpxService.lectureVitale(this._view);
          const infosPatientCarte: any[] = [];
          for (let [index, patient] of listPatientsCarte.Patients.entries()) {
            infosPatientCarte.push({
              id: index,
              i_birthRank: patient.i_birthRank,
              i_quality: patient.i_quality,
              s_birthday: moment(patient.s_birthday, "DDMMYYYY").format("DD/MM/YYYY"),
              s_birthname: patient.s_birthname,
              s_certifiedNir: patient.s_certifiedNir ? patient.s_certifiedNir : undefined,
              s_given: patient.s_given,
              s_insC: patient.s_insC ? patient.s_insC : undefined,
              s_name: patient.s_name,
              s_nir: patient.s_nir ? patient.s_nir : undefined
            });
          }
          const patientCardOk = infosPatientCarte.find(p => p.id === res.id && p.s_certifiedNir === res.s_certifiedNir);
          if (!patientCardOk) {
            load.destroy();
            this._modalService.openAlert(this._view, 'Mauvaise carte Vitale', 'La carte Vitale utilisée pour sélectionner un patient n\'est pas la même que la carte actuellement présente dans le lecteur.');
          } else {
            load.destroy();
            await this._getInsFromVitale(res, infos);
          }
        }
      } finally {
        modal.destroy();
        sub.unsubscribe();
      }
    });
  }

  public closeInsiModal(object?: InsiInfosPatient): void {
    if (object) {
      this.closeEmitter.emit(object);
    } else {
      this.closeEmitter.emit();
    }
  }
}
